import { api } from "./apiClient";

export const rfiAPI = {
  listByProject: (projectId) => api.get(`/projects/${projectId}/rfis`),
  create: (projectId, payload) =>
    api.post(`/projects/${projectId}/rfis`, payload),
  assign: (projectId, rfiId, payload) =>
    api.post(`/projects/${projectId}/rfis/${rfiId}/assign`, payload),
  answer: (projectId, rfiId, payload) =>
    api.post(`/projects/${projectId}/rfis/${rfiId}/answer`, payload),
  close: (projectId, rfiId, payload) =>
    api.post(`/projects/${projectId}/rfis/${rfiId}/close`, payload),
  updateAttachments: (projectId, rfiId, payload) =>
    api.post(`/projects/${projectId}/rfis/${rfiId}/attachments`, payload),
  getAttachments(projectId, rfiId) {
    return api.get(`/projects/${projectId}/rfis/${rfiId}/attachments`);
  },
  sendInternal: (projectId, formData) =>
    api.post(`/projects/${projectId}/internal-rfi/email`, formData, {
      timeout: 120000,
      headers: { "Content-Type": "multipart/form-data" },
    }),
};
